import React, { useState } from 'react';
import { Form, Button, Card, Container, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Logo from '../assets/logo.png';

const Login = ({ setToken }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const response = await axios.post(`${API_URL}/login`, { email, password });
            
            const token = response.data.access_token;
            const userName = response.data.user_name;
            const userEmail = response.data.user_email; 
            
            localStorage.setItem('token', token);
            localStorage.setItem('userName', userName);
            localStorage.setItem('userEmail', userEmail); 
            
            setToken(token);
        } catch (err) {
            const errorMsg = err.response?.data?.detail || "Invalid credentials. Please try again.";
            setError(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container fluid className="d-flex align-items-center justify-content-center bg-light" style={{ minHeight: "100vh" }}>
            <Card style={{ width: '400px' }} className="shadow-lg border-0 rounded-4">
                <Card.Body className="p-4">
                    <div className="text-center mb-4">
                        <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{width: '60px', height: '60px'}}>
                            <img src={Logo} alt='Logo' className='rounded-circle' style={{width: '60px', height: '60px'}} />
                        </div>
                        <h3 className="fw-bold">Welcome Back</h3>
                        <p className="text-muted small">Login to your Code Reviewer account</p>
                    </div>
                    
                    {error && <Alert variant="danger" className="small py-2 text-center">{error}</Alert>}
                    
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Email Address</Form.Label>
                            <Form.Control 
                                type="email" 
                                placeholder="name@example.com" 
                                required 
                                className="py-2"
                                onChange={(e) => setEmail(e.target.value)} 
                            />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label className="small fw-bold">Password</Form.Label>
                            <Form.Control 
                                type="password" 
                                placeholder="••••••••" 
                                required 
                                className="py-2"
                                onChange={(e) => setPassword(e.target.value)} 
                            />
                        </Form.Group>

                        {/* --- Forget Password Link --- */}
                        <div className="text-end mb-4">
                            <Link to="/forget-password" style={{ fontSize: '0.8rem' }} className="text-decoration-none text-primary fw-bold">
                                Forgot Password?
                            </Link>
                        </div>

                        <Button 
                            variant="primary" 
                            className="w-100 py-2 fw-bold mb-3 shadow-sm rounded-pill" 
                            type="submit" 
                            disabled={loading}
                        >
                            {loading ? (
                                <><Spinner animation="border" size="sm" className="me-2"/> Signing in...</>
                            ) : (
                                "Sign In"
                            )}
                        </Button>
                    </Form>

                    <div className="text-center mt-3 border-top pt-3">
                        <small className="text-muted">
                            New here? <Link to="/register" className="text-decoration-none fw-bold text-primary">Create an account</Link>
                        </small>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Login;